'use strict';

/**
 * View for rendering the selection of a set in modal update/select set
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CompositeView = require('base/Colido.CompositeView');
var RestrictionModalView = require('modules/base/views/layout/restriction-sets-modal');

var template = require('modules/collection/modules/set/templates/partials/select-set-sets-list.hbs');

var SelectSetSetsListView = CompositeView.extend({
    template: template,

    childViewContainer: '.list',

    collectionEvents: {
        'add change sync': 'render',
    },

    ui: {
        'addSetBox': '.box-add-set',
        'toggleCreation': '[data-action="toggle-creation"]',
        'createButton': '[data-action="create"]',
        'resetButton': '[data-action="reset"]',
        'selectSet': '[data-action="select-set"]',
        'nameInput': 'input[name="name"]',
    },

    /**
     * Indicates, if view is used for recent item rendering
     * @type {boolean}
     */
    isRecent: false,

    /**
     * Should the messenger be showed?
     * @type {boolean}
     */
    showCreateMessage: true,

    events: {
        'click @ui.toggleCreation': 'onToggleCreation',
        'click @ui.createButton': 'onCreateSet',
        'click @ui.resetButton': 'onResetCreate',
        'click @ui.selectSet': 'onSelectSet',
        'keyup @ui.nameInput': 'onCheckName',
        'keydown @ui.nameInput': 'onCheckName',
        'change @ui.nameInput': 'onCheckName',
    },

    childViewOptions: function(model, index) {
        return {
            isRecent: this.getOption('isRecent'),
        };
    },

    /**
     * Is triggered, when the main storage is selected
     * We will notify the layoutview
     */
    onSelectSet: function() {
        this.triggerMethod('set:selected', this.model);
    },

    /**
     * Toggles the edit mode of the box
     * @return {void}
     */
    onToggleCreation: function() {
        if (App.user.get('canCreateSet') !== true) {
            event.preventDefault();
            // buggy! :'(
            // this.showRestrictionModal();
            return;
        }

        var mode  = this.ui.addSetBox.attr('data-mode');
        var empty = this.ui.addSetBox.attr('data-empty');

        if (empty === true || empty === 'true') {
            if (mode === 'view') {
                this.ui.addSetBox.addClass('box-stacked').removeClass('box-empty');
                this.ui.addSetBox.attr('data-mode', 'edit');
                this.ui.createButton.prop('disabled', true);
                this.ui.nameInput.focus();
            } else {
                this.ui.addSetBox.removeClass('box-stacked').addClass('box-empty');
                this.ui.addSetBox.attr('data-mode', 'view');
            }
        }
    },

    /**
     * Cancles the creation of a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    onResetCreate: function() {
        event.preventDefault();
        this.ui.nameInput.val('');
        this.onToggleCreation();
    },

    /**
     * Checks the name to enable/disable submit button
     * @param {object} event The event that has triggered the function
     */
    onCheckName: function() {
        this.ui.createButton.prop('disabled', this.ui.nameInput.val().length <= 0);
    },

    /**
     * Creates a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    onCreateSet: function(event) {
        event.preventDefault();
        var name = this.ui.nameInput.val();
        var catalog = this.collection.catalog;

        App.radio('collection:set').execute('create:set', catalog, name, this.getOption('showCreateMessage'));

        // Disable edit mode
        this.ui.nameInput.val('');
        this.onToggleCreation();
    },

    /**
     * Marionette onShow callback.
     * We will jump into create dialog, when there is forceAdd Option
     */
    onShow: function() {
        if (this.getOption('forceAdd')) {
            this.onToggleCreation();
        }
    },

    showRestrictionModal: function(model){
        var restrictionModalView = new RestrictionModalView({model: model});
        var options = {
            additionalClassName: 'modal-center modal-restriction',
            additionalBgClassName: 'light-bg',
        };
        App.addModal(restrictionModalView, options);
    },
});

module.exports = SelectSetSetsListView;